import * as config from '../config.json';

export const environment = {
  production: false,
  version: config.VERSION.BUILDNUMBER
};
